<template>
  <div>
    <div class="title">查询优惠券活动</div>
    <el-form class="queryForm" ref="form" label-width="80px">
      <el-form-item label="优惠券id">
        <el-input v-model="searchForm.couponId" placeholder="请输入优惠券id"
                  :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="用户id">
        <el-input v-model="searchForm.userAccount" placeholder="请输入用户id" :clearable="true"></el-input>
      </el-form-item>

    </el-form>

    <div class="button_container">
      <el-button class="queryButton" type="primary" @click="queryCouponByVariable">检索</el-button>
    </div>
    <div class="flex-col coupon_list align-center">
      <div class="coupon_item flex-col align-center" v-for="item of couponList" :key="item.id">
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">优惠券id：</span>
          <span class="value">{{ item.couponId }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">优惠券名：</span>
          <span class="value">{{ item.coupoName }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">启用时间：</span>
          <span class="value">{{ item.effectiveTime }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">作废时间：</span>
          <span class="value">{{ item.failureTime }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-start">
          <span class="label">支持门店：</span>
          <div class="value flex-col">
            <div v-for="pos of item.posList" :key="pos.id" style="margin-bottom: 10px">
              {{ pos.pos }}
            </div>
          </div>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">对应产品：</span>
          <span class="value">{{ item.productName }}({{ item.availableProductType }})</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">活动id：</span>
          <span class="value">{{ item.activityId }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">持有者：</span>
          <span class="value">{{ item.userAccount }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">优惠券状态：</span>
          <span class="value">{{ item.useState }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">订单id：</span>
          <span class="value">{{ item.orderId }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {queryCoupon} from "../../api/coupon";
import {findPartnerByPartnerId, queryPosNameByPosId, queryProductList} from "../../graphql/api";
import {v4 as uuidv4} from "uuid";
import {removeEmptyProperties} from "../../util";

export default {
  name: "coupon_list",
  data() {
    return {
      phone: "",
      plate: "",
      name: "",
      beginTime: "",
      endTime: "",
      searchForm: {
        couponId: "",
        userAccount: "",
      },

      couponList: []
    }
  },
  mounted() {
    this.getCouponList();
  },
  methods: {
    queryCouponByVariable() {
      let searchForm = removeEmptyProperties(this.searchForm);
      this.getCouponList(searchForm)
    },

    getCouponList(variables) {
      queryCoupon({
        page: 1,
        size: 1000,
        partnerId: sessionStorage.getItem('partnerid'),
        ...variables
      }).then(res => {
        console.log('查询优惠券', res);
        if (res.data.queryAllCoupon) {
          this.couponList = res.data.queryAllCoupon;
          this.couponListProcess(this.couponList)
        } else {
          alert('查询优惠券列表为空')
        }
      }).catch(error => {
        console.log('查询优惠券异常', error);
        alert(error)
      })
    },

    // 优惠券列表数据处理
    couponListProcess(data) {
      data.forEach(item => {
        if(item.state === 1){
          this.$set(item, "useState", '未使用')
        }else if(item.state === 2){
          this.$set(item, "useState", '已使用')
        }else if(item.state === -1){
          this.$set(item, "useState", '已过期')
        }


        let posList = item.availablePosId.split(",");
        let posNameList = []
        for (const pos of posList) {
          queryPosNameByPosId({
            posId: pos
          }).then(res => {
            if (res.data.findPosInfoByPosId) {
              posNameList.push(
                  {
                    id: uuidv4(),
                    pos: res.data.findPosInfoByPosId.pos.name
                  }
              )
            } else {
              console.log(`门店[${pos}]异常`);
            }

          }).catch(error => {
            console.log('查询门店异常', error);
          })
        }

        this.$set(item, "posList", posNameList);
      })
    }
  }
}
</script>

<style lang="scss" src="../../css/coupon_activity_list.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/coupon_list.vue